import { render } from "./editProjectType.vue?vue&type=template&id=9400cf60&scoped=true&ts=true"
import script from "./editProjectType.vue?vue&type=script&lang=ts"
export * from "./editProjectType.vue?vue&type=script&lang=ts"

import "./editProjectType.vue?vue&type=style&index=0&id=9400cf60&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9400cf60"]])

export default __exports__